import React from "react"

import { useAppSelector } from "redux/hooks"
import { selectContent } from "redux/features/dialog/dialogSlice"

export function withModalSubscriptionPlan<GenericType>(
  WrappedComponent: React.ComponentType<GenericType>,
) {
  const WithModalSubscriptionPlan = (props: GenericType) => {
    const content = useAppSelector((state) => selectContent(state))

    const { plan } = content
    return <WrappedComponent {...props} plan={plan} />
  }

  return WithModalSubscriptionPlan
}
